import { BetaBadge, DataSourceIcon } from '@/lib';
import { DataSourceType } from '@/models/dataSource';
import { FC } from 'react';
import { twMerge } from 'tailwind-merge';

type DataSourceTypeCardProps = {
  dataSourceType: DataSourceType;
  className?: string;
  onClick?: VoidFunction;
  showBetaBadge?: boolean;
};

export const DataSourceTypeCard: FC<DataSourceTypeCardProps> = ({ dataSourceType, onClick, className, showBetaBadge = false }) => {
  return (
    <div
      className={twMerge(
        'flex w-full cursor-not-allowed flex-wrap items-center justify-between gap-4 rounded-xl border border-quaternary-300 bg-white-100 p-4 shadow lg:flex-nowrap hover:border-gray-300 hover:shadow-sm hover:scale-105 motion-safe:transition-all motion-safe:duration-200 motion-reduce:transition-none',
        onClick && 'cursor-pointer',
        className
      )}
      onClick={onClick}
    >
      <div className='flex flex-wrap items-center gap-3 lg:flex-nowrap'>
        <DataSourceIcon type={dataSourceType.id} />
        <h3 className='text-base font-semibold uppercase tracking-wide text-gray-700'>{dataSourceType.name}</h3>
      </div>
      {showBetaBadge && <BetaBadge />}
    </div>
  );
};
